const swiperPress = new Swiper(".press-swiper .swiper-press", {
  autoplay: { delay: 5000 },
  slidesPerView: 1,
  loop: true,
  navigation: {
    nextEl: ".swiper-button-next-press",
    prevEl: ".swiper-button-prev-press",
  },
  pagination: {
    el: ".swiper-pagination-press",
  },
  breakpoints: {
    768: {
      slidesPerView: 3,
      spaceBetween: 40,
    },
  },
});
